import { renderDate } from 'shared/intrasyncUtils';
import { ScheduleGridBodyCellProps } from '@intrasync/react';

interface IFCTrackerLeftBodyCellProps extends ScheduleGridBodyCellProps {
  scheduleDate: string;
  rowCount: number;
}

const IFCTrackerLeftBodyCell = (props: IFCTrackerLeftBodyCellProps) => {
  // console.log('LeftBody props', props);
  const { rowCount, scheduleDate } = props;
  return (
    <div
      style={{
        border: '1px solid #eee',
        ...props.style,
        ...props.styles,
      }}
    >
      <b>{renderDate(scheduleDate)}</b>
      {rowCount >= 1 && (
        <b>
          {rowCount} {rowCount === 1 ? 'piece' : 'pieces'}
        </b>
      )}
    </div>
  );
};

export default IFCTrackerLeftBodyCell;
